import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { getMenuItem } from "../../js/admin";
import auth from "../../js/auth";
import { ReactComponent as CancelIcon } from "./cancel.svg";

const MenuItem = ({ o, myStatus, local, localStorage, cancelOrder, incrementOrder, tableMateDiscount, discount }) => {
    let lastToDeliver;
    let __quantity;

    const menuItem = getMenuItem(o.menuItem.id);

    function price(o) {
        try {
            if (o.childOrders)
                return o.discountedPrice + o.discount + o.tableMateDiscount - o.childOrders.filter(ooo => /*!ooo.separate &&*/ ooo.price).map(ooo => (ooo.addition ? 1 : -1) * ooo.price).reduce((a, b) => a + b, 0);
            else
                return o.discountedPrice + o.discount + o.tableMateDiscount;
        } catch (ex) {
            return o.price;
        }
    }
    function fullprice(o) {
        return o.discountedPrice /* + o.childOrders.filter(ooo => ooo.separate && ooo.price).map(ooo => (ooo.addition ? 1 : -1) * ooo.price).reduce((a, b) => a + b, 0)*/;
    }

    function getDiscount(discountId) {
        return myStatus.restaurant_discounts.find(d => d.id == discountId);
    }

    const getQuantityLabel = (o, parentOrderQuantity) => {
        if (typeof parentOrderQuantity == "undefined") {
            parentOrderQuantity = 1;
        }
        var quantityType = o.quantityType ? o.quantityType : menuItem.quantityType;
        if (quantityType == 'undefined' || quantityType == '' || quantityType == 'none')
            return '';
        // if (o.quantity == 1 && quantityType == 'pcs')
        // return '';
        var quantityLabel = "";
        var quantity = Math.round(1000 * o.quantity * (parentOrderQuantity > 10 ? 1 : parentOrderQuantity)) / 1000;
        menuItem.availableQuantities.forEach(function (q) {
            if (Math.abs(q.quantity) == Math.abs(quantity)) {
                quantityLabel = q.quantityType.name;
                if (quantityLabel == "N/A")
                    quantityLabel = "";
            }
        });
        if (quantityLabel != '' && menuItem.entityType == 'Meal') {
            return (quantity < 0 ? quantity + " " : "") + quantityLabel;
        } else {
            var v = (quantityLabel != '' ? quantityLabel + " " : "");
            v += ((Math.abs(quantity) == 1 || parentOrderQuantity != 1) && quantityType == 'pcs') ? '' : ("(" + ((quantity) + (quantity == 1 && quantityType == 'pcs' ? '' : quantityType == '' ? "" : ' ' + local[quantityType])) + ")");
            return v;
        }

    }

    return (
        <>
            {/* To Deliver Section */}
            {o.todeliver &&
                (!myStatus.tableNumber) &&
                (typeof lastToDeliver === "undefined" ||
                    lastToDeliver !== o.todeliver) && (
                    <div className="todeliver">
                        {local.date_of_delivery}:{" "}
                        {moment(o.todeliver)
                            .locale(localStorage.language)
                            .format("MMMM-DD dddd")}
                    </div>
                )}

            {/* Main MenuItem */}
            <div
                state={o.state}
                className={`menuItem-name ${o.paid ? "paid" : ""}`}
                title={menuItem.description !== "N/A" ? menuItem.description : ""}
            >
                {/* Paid Badge */}
                {o.paid && <div className="paid">{local.paid}</div>}

                {/* Item Content */}
                <div
                >
                    {/* Row with name, approval, price */}
                    <div className="main-row"
                    >
                        <div className="kiosk-menuItem-name-label">
                            <span >
                                {menuItem.name} {getQuantityLabel(o) !== "" && getQuantityLabel(o)}
                            </span>
                        </div>

                        {/* Spacer */}
                        <div className="spacer"></div>

                        {/* Action buttons if order is selected */}
                        {!o.customPrice &&
                            <div className="kiosk-actions">
                                <div className="kiosk-decrement-increment-order">
                                    <div key={o.orderIds}
                                        onClick={() => {
                                            cancelOrder(
                                                [o.orderIds[o.orderIds.length - 1]],
                                                o.orderIds.length > 1
                                            )
                                        }}
                                        className="kiosk-decrement-order icon-minus"
                                    ></div>
                                    {/* Count */}
                                    {o.count > 1 ? (
                                        <div className="kiosk-menuItem-order-count kiosk-menuItem-order-count-multiple"
                                        >
                                            {o.count} x&nbsp;
                                        </div>
                                    ) : (
                                        <div
                                            className="kiosk-menuItem-order-count"
                                        >
                                            {o.count}
                                        </div>
                                    )}
                                    <div
                                        onClick={() => incrementOrder([o.orderIds[0]])}
                                        className="kiosk-increment-order icon-plus"
                                    />
                                </div>
                                <CancelIcon
                                    onClick={() => cancelOrder(o.orderIds)}
                                    className="kiosk-cancel-order icon-cancel"
                                />
                            </div>}

                        {/* Price */}
                        <div
                            className="kiosk-menuItem-price"
                        >
                            {price(o) / o.count} {myStatus.restaurant_base_currency.name}
                        </div>
                    </div>

                    {/* Comment */}
                    {o.comment && (
                        <div className="kiosk-menuItem-comment">
                            {o.comment.split(";").map((c, i) => (
                                <span key={i} className="user_comment">
                                    {c}
                                </span>
                            ))}
                        </div>
                    )}

                    {/* Child Orders */}
                    {o.childOrders.map((child, i) => {
                        const menuItem2 = getMenuItem(child.menuItem.id);
                        return (
                            <div className="kiosk-child-order-row"
                                key={i}
                            >
                                <div className="kiosk-menuItem-name-label">
                                    {menuItem2.name} {getQuantityLabel(child, __quantity)}
                                </div>
                                <div
                                    className="kiosk-menuItem-price"
                                >
                                    {child.fullPrice > 0 && (
                                        <>
                                            {child.addition ? child.fullPrice : `-${child.fullPrice}`} {myStatus.restaurant_base_currency.name}
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    {/* Discounts */}
                    {o.discount > 0 && (
                        <div
                            key="discounts"
                        >
                            {(
                                o.discountComment.split(";")
                                    .filter((s) => s)
                            ).map((s, idx) => {
                                const parts = s.split(",");
                                return (
                                    <React.Fragment key={idx}>
                                        <div className="kiosk-menuItem-name-label">
                                            {getDiscount(parts[0]).name} {parts[2]}
                                        </div>
                                        <div
                                            className="kiosk-menuItem-price"

                                        >
                                            -{auth.round(parts[1])} {myStatus.restaurant_base_currency.name}
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>

                    )}
                    {price(o) / o.count != fullprice(o) && (
                        <div >
                            <div className="" >
                            </div>
                            <div
                                className="kiosk-menuItem-price final-price"

                            >
                                <div className="final-price">
                                    {fullprice(o)} {myStatus.restaurant_base_currency.name}
                                </div>
                            </div>
                        </div>)}

                </div>

            </div>
        </>
    );


};
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            menuCategories: props.rootReducer.menuCategories ? props.rootReducer.menuCategories.sort((a, b) => b.entityType.localeCompare(a.entityType)).filter(c => c.isActive && c.isTop && c.activeMenuItems.length > 0) : [],
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
        };
    }
    return {};
};

export default connect(mapStateToProps)(MenuItem);
